import axiosInstance from 'api/axiosInstance'
import { type Country } from 'types/api/country'

export interface GeoBlockSettings {
    geo_block: boolean
    countries: number[]
    regions: number[]
}

export interface UpdateGeoBlockData {
    countries: number[]
    regions: number[]
    geo_block?: boolean
}

export const getCountries = async (): Promise<Country[]> => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/countries'
    })

    return data?.data
}

export const getGeoBlock = async (): Promise<GeoBlockSettings> => {
    const { data } = await axiosInstance({
        method: 'GET',
        url: '/api/user/geo-block'
    })

    return data
}
export const setCountries = async (geoData: UpdateGeoBlockData) => {
    const { data } = await axiosInstance({
        method: 'PUT',
        url: '/api/user/geo-block',
        data: geoData
    })

    return data
}